import React, { useEffect, useState } from 'react';

import OEMultiSelectItem from './_oe-multi-select-item/_oe-multi-select-item';
import './oe-multi-select.scss';

interface IProps<T extends string> {
    options: { id: string; label: string; value: T }[];
    values: T[];
    onChange: (values: T[]) => void;
    withCheckmark?: boolean;
}

const OEMultiSelect = <T extends string, >(props: IProps<T>) => {
    const { options, values, onChange, withCheckmark } = props;
    const [selectedValues, setSelectedValues] = useState([]);

    const handleChange = (value: T) => {
        let newValues = [];

        if (selectedValues.includes(value)) {
            newValues = selectedValues.filter(el => el !== value);
        } else {
            newValues = [...selectedValues];
            newValues.push(value);
        }

        setSelectedValues(newValues);
        onChange(newValues);
    };

    const isArraysEqual = (first: T[], second: T[]) => {
        if (first.length !== second.length) return false;

        const sortedFirst = first.slice().sort((a, b) => a.localeCompare(b));
        const sortedSecond = second.slice().sort((a, b) => a.localeCompare(b));

        sortedFirst.forEach((el, index) => {
            if (el !== sortedSecond[index]) {
                return false;
            }
        });
        return true;
    };

    useEffect(() => {
        if (!isArraysEqual(selectedValues, values)) {
            setSelectedValues(values);
        }
    }, [values]);

    return (
        <div className='multi-select'>
            <div className='multi-select__options'>
                {options.map(({ value, ...otherProps }) =>
                    <OEMultiSelectItem
                        key={value}
                        withCheckmark={withCheckmark}
                        isSelected={selectedValues.includes(value)}
                        onChange={handleChange}
                        value={value}
                        {...otherProps}
                    />
                )}
            </div>
        </div>
    );
};

export default OEMultiSelect;
